<template>
  <div class="">
    <book-entry></book-entry>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BookEntry from "@/components/accounting/book-entries/index.vue";

export default {
  props: {},
  components: {
    BookEntry,
  },
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  created() {
    this.notifyQueue({
      text: "Contabilità",
      path: "",
      level: 1,
    });
    this.notifyQueue({
      text: "Foglio cassa",
      path: "module.CONT.FCAS",
      level: 2,
    });
  },
};
</script>
